import { httpGet } from "@/services/api.service";
import { ENDPOINT_TAGS_CONFIG } from "@/common/constants/api";
import { hasPlusCyberAccess } from "@/services/user/user.service";

export { _getTagsConfig as getTagsConfig };

const _getTagsConfig = async () => {
  try {
    const url = ENDPOINT_TAGS_CONFIG;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);
    let tagList = data.tags;
    return hasPlusCyberAccess()
      ? tagList
      : tagList.filter((tag) => !tag.isCyber);
  } catch (error) {
    console.error("Issue getting tags config in tags.service.js:", error);
    return null;
  }
};
